export enum ValidationStatus {
  VALIDATING = 'validating',
  AUTHENTICATED = 'authenticated',
  NEEDS_LOGIN = 'needs-login',
  SESSION_EXPIRED = 'session-expired',
  ERROR = 'error',
}
